module.exports = __webpack_public_path__ + "img/fast-splitter-north.31287870.png";